import { WorklistItemStatus } from 'generated/graphql';
import { ReportStatus, type ReportStatuses } from 'domains/reporter/Reporter/state';

// Candidate exam statuses eligible to appear in Link Exams.
export const BASE_LINKABLE_WORKLIST_STATUSES: ReadonlyArray<WorklistItemStatus> = [
  WorklistItemStatus.Pending,
  WorklistItemStatus.InProgress,
];

// Candidate exam statuses when expanded linking is enabled by feature flag.
export const EXPANDED_LINKABLE_WORKLIST_STATUSES: ReadonlyArray<WorklistItemStatus> = [
  ...BASE_LINKABLE_WORKLIST_STATUSES,
  WorklistItemStatus.Scheduled,
  WorklistItemStatus.InTransit,
];

// Current report statuses from which link/unlink actions are permitted.
export const LINKABLE_REPORT_STATUSES: ReadonlyArray<ReportStatuses> = [
  ReportStatus.Init,
  ReportStatus.Idle,
  ReportStatus.ProvisionalSubmit,
  ReportStatus.Submitting,
  ReportStatus.Cancelling,
];

// Maximum number of prior studies that can be loaded in the Viewer simultaneously.
export const MAX_VIEWER_PRIOR_STUDIES = 10;

// Maximum number of exams (excluding the primary exam) that can be linked to a case.
export const MAX_LINKED_CASES = 10;
